export const fetch_categories = (state = ['lund', 'kkk'], action) => {
	if (action.type == 'RECEIVE_CATEGORIES') {
		return action.payload
	}
  return state;
}

export const is_fetching_categories = (state = 0, action) => {
	switch (action.type) {
		case 'REQUEST_CATEGORIES':
	  		return state + 1;
		case 'RECEIVE_CATEGORIES':
	  		return state - 1;
		default:
	  		return state;
	}
};

export const search_value = (state = null, action) => {
	switch (action.type) {
		case 'SET_SEARCH_VALUE':
	  		return action.payload;
		default:
	  		return state;
	}
};